import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {IntlProvider, addLocaleData} from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_pt from 'react-intl/locale-data/pt';
import messages_en from "./translations/en.json";
import messages_pt from "./translations/pt.json";
import moment from 'moment';
import 'moment/locale/pt-br';
import momentLocalizer from 'react-widgets-moment';


addLocaleData([...locale_en, ...locale_pt]);

const messages = {
    'en': messages_en,
    'pt-br': messages_pt
};
const language = "en";
//const language = "pt-br";
moment.locale(language);
momentLocalizer();

ReactDOM.render(
  <IntlProvider locale={language} messages={messages[language]}>
    <App/>
  </IntlProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
